<template>
    <b-card header-class="bar-color2" :body-class="bodyClass" >
        <template v-slot:header>
            <timeline-header
                :date="data.date"
                :time="data.date"
                :title="$t('surgery.basalStudy')"
                @edit="showModal"
                is-editable
            />
        </template>

        <div class="d-flex d-md-inline-flex flex-column mr-3">
            <p>
                <label class="form-label">{{ bloodTestFields.fviii_c.label }}:</label>
                {{ data.fviii_c | valueOrEmpty }} <span v-if="data.fviii_unit">{{ data.fviii_unit }}</span>
            </p>
            <p>
                <label class="form-label">{{ bloodTestFields.fviii_cr.label }}:</label>
                {{ data.fviii_cr | valueOrEmpty }} <span v-if="data.fviii_unit">{{ data.fviii_unit }}</span>
            </p>
        </div>

        <div class="d-flex d-md-inline-flex flex-column mr-3">
            <p>
                <label class="form-label">{{ bloodTestFields.hemoglobin.label }}:</label>
                {{ data.hemoglobin | valueOrEmpty }} <span>{{ bloodTestFields.hemoglobin.help_text }}</span>
            </p>
            <p>
                <label class="form-label">{{ bloodTestFields.platelets.label }}:</label>
                {{ data.platelets | valueOrEmpty }} <span>{{ bloodTestFields.platelets.help_text }}</span>
            </p>
        </div>

        <div class="d-flex d-md-inline-flex flex-column mr-3">
            <p>
                <label class="form-label">{{ surgeryFields.basal_inhibitor_actual.label }}:</label>
                {{ data.basal_inhibitor_actual | valueOrEmpty }}
            </p>
            <p>
                <label class="form-label">{{ surgeryFields.is_basal_sample_frozen.label }}:</label>
                {{ data.is_basal_sample_frozen | yesno | capitalize }}
            </p>
        </div>

        <b-modal
            :id="modalId"
            size="xl"
            centered
            hide-footer
            hide-header
            no-close-on-backdrop
        >
            <basal-study
                class="add-surgery-page"
                ref="basalStudy"
            />

            <p v-if="generalError" class="invalid-feedback invalid">
                {{ this.$t('error.general') }}
            </p>

            <create-cancel-buttons
                :ok-title="$t('utils.save')"
                :ok-function="save"
                :cancel-title="$t('utils.cancel')"
                :cancel-function="cancel"
            />
        </b-modal>

    </b-card>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import TimelineElementMixin from "@/components/surgery/detail/timeline/TimelineElementMixin";
    import TimelineHeader from "@/components/surgery/detail/timeline/TimelineHeader";
    import BasalStudy from "@/components/surgery/create/BasalStudy";
    import EditableByPopupMixin from "@/components/surgery/detail/timeline/EditableByPopupMixin";
    import CreateCancelButtons from "@/components/surgery/detail/elements/CreateCancelButtons";
    import {logRequestError} from "@/utils/utils";

    export default {
        name: "TimelineBasalStudy",
        components: {CreateCancelButtons, BasalStudy, TimelineHeader},
        mixins: [TimelineElementMixin, EditableByPopupMixin],
        computed: {
            ...mapState(['bloodTestFields', 'surgeryFields', 'surgery']),
        },
        methods: {
            ...mapActions(['updateBloodTest']),
            async save() {
                if (await this.$refs.basalStudy.validate()) {
                    try {
                        await this.updateBloodTest({pk: this.surgery.basal_blood_test.id, data: this.surgery.basal_blood_test});
                        await this.updateSurgery({pk: this.surgery.id, data: this.surgery});
                        this.closeModal();
                        this.$emit('save');
                        this.generalError = false;
                    } catch (error) {
                        logRequestError(error);
                        this.generalError = true;
                    }
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "src/custom";

    p {
        @extend .mb-2;
    }
</style>